import React, { useState } from "react";
import "../FormProvComercializadorLealtad/FormProvComercializadorLealtad.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const FormAdminProvLealtad = () => {
  const navigate = useNavigate();
  const [User, setUser] = useState({
    nameAndLastName: "",
    cuit: "",
    email: "",
    placeOfResidence: "",
    street: "",
    numberStreet: "",
  });

  const formdataprov = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_COMPLETE_ADMIN_SUPPLIER_LEALTAD}`,
        { User }
      );
      Swal.fire({
        icon: "success",
        title: "Bienvenido!",
        text: "Has completado tu perfil correctamente." || res.data.message,
      });
      navigate("/portal-admin-proveedor-lealtad/inicio");
    } catch (error) {}
  };

  const handleNumericInputChange = (fieldName, value) => {
    // Filtrar caracteres no numéricos solo para CUIT, número y código postal
    let numericValue = value;
    if (["cuit", "numberStreet"].includes(fieldName)) {
      numericValue = value.replace(/[^0-9]/g, "");
    }
    setUser({ ...User, [fieldName]: numericValue });
  };

  return (
    <div className="allprovlealtad">
      <div className="allformprovlealtad">
        <p className="tittleformprvlealtad">Ingrese sus datos</p>
        <div className="dosplayinputProvlealtad">
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Nombre Completo</label>
            <input
              className="inputupdateProvlealtad"
              type="text"
              value={User.nameAndLastName || ""}
              onChange={(e) =>
                setUser({ ...User, nameAndLastName: e.target.value })
              }
            />
          </div>
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Cuit</label>
            <input
              className="inputupdateProvlealtad"
              type="text"
              maxLength={11}
              value={User.cuit || ""}
              onChange={(e) => handleNumericInputChange("cuit", e.target.value)}
            />
          </div>
        </div>
        <div className="dosplayinputProvlealtad">
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Email</label>
            <input
              className="inputupdateProvlealtad"
              type="email"
              value={User.email || ""}
              onChange={(e) => setUser({ ...User, email: e.target.value })}
            />
          </div>
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Lugar de residencia</label>
            <input
              className="inputupdateProvlealtad"
              type="text"
              value={User.placeOfResidence || ""}
              onChange={(e) =>
                setUser({ ...User, placeOfResidence: e.target.value })
              }
            />
          </div>
        </div>

        <div className="dosplayinputProvlealtad">
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Calle</label>
            <input
              className="inputupdateProvlealtad"
              type="text"
              value={User.street || ""}
              onChange={(e) => setUser({ ...User, street: e.target.value })}
            />
          </div>
          <div className="boxinputprovlealtad">
            <label className="labelformprovlealtad">Numero</label>
            <input
              className="inputupdateProvlealtad"
              type="number"
              value={User.numberStreet || ""}
              onChange={(e) =>
                handleNumericInputChange("numberStreet", e.target.value)
              }
            />
          </div>
        </div>
        <div className="boxprovbuttonlealtad">
          <button className="buttonprovlealtad" onClick={formdataprov}>
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormAdminProvLealtad;
